export enum DoubleWheelColorsIndex {
  Blue = 1,
  Yellow,
  Red,
  Purple,
  Green,
  Wild,
  Different,
}
